export const NAME = 'other';

export const NOT_PERSISTED = false;
